import Action from './models'

export default Action
